
function addCartActionProductBlock(){
  // 商品一覧（トップページの「RANKING」や「NEW ITEM」、商品詳細ページの「関連商品」など含む）
  var shopifyAjaxAddURL = theme.routes.cart_add_url + '.js';
  var shopifyAjaxStorePageURL = theme.routes.search_url;
  $('.blocklayout .product-form[data-ajax="true"], .blocklayout-custom .product-form[data-ajax="true"]').each(function() {
    $(this).on('submit', function (evt) {
      evt.preventDefault();
      var $form = $(this);
      $form.find('button[type="submit"]').attr('disabled', 'disabled').html(theme.strings.products_product_adding_to_cart);

      $.post(shopifyAjaxAddURL, $form.serialize(), function (data) {
        // カートアイコンのカウンターを動的に更新
        var cartNumitems = $('.page-header .action-cart .numitems');
        var numitemsValue = cartNumitems.text();
        numitemsValue++;
        cartNumitems.text(numitemsValue);

        var $btn = $form.find('button[type="submit"]').removeAttr('disabled');
        $btn.html(theme.icons.tick + ' ' + theme.strings.products_product_added_to_cart);
        setTimeout(function () {
          $btn.html(theme.strings.products_product_add_to_cart);
        }, 3000);
        if ($btn.next('.added-cta').length == 0) {
          var $cta = $('<a></a>').attr('href', theme.routes.cart_url);
          $cta.append($('<span class="beside-img">').html(theme.strings.products_product_added_cta));
          $cta.append(' ').append(theme.icons.chevronRight);
          $cta = $cta.wrap('<div class="added-cta">').parent().hide().insertAfter($btn);
          $cta.slideDown(500, function () {
            $(this).addClass('show');
            if ($btn.closest('#fancybox-content').length) {
              $.fancybox.resize();
            }
          });
        }
        $.get(shopifyAjaxStorePageURL, function (data) {
          var $newCartObj = $(data).find('.page-header .cartsummary');
          var $currCart = $('.page-header .cartsummary');
          $currCart.html($newCartObj.html());
        });
      }, 'text').fail(function (data) {
        $form.find('button[type="submit"]').removeAttr('disabled').html(theme.strings.products_product_add_to_cart);
        if (typeof data != 'undefined' && typeof data.status != 'undefined') {
          var jsonRes = $.parseJSON(data.responseText);
          theme.showQuickPopup(jsonRes.description, $form.find('button[type="submit"]:first'));
        } else {
          $form.addClass('noAJAX');
          $form.submit();
        }
      });
    });
  });

  // pagefly
  $('.pf-product-form').each(function() {
    var pfAddCartBtn = $(this).find('button[data-pf-type="ProductATC"]');
    var pfQuantity = $(this).find('input[name="quantity"]');
    pfAddCartBtn.on('click', function (evt) {
      evt.preventDefault();
      // カートアイコンのカウンターを動的に更新
      var cartNumitems = $('.page-header .action-cart .numitems');
      var numitemsValue = cartNumitems.text();
      var quantityValue = pfQuantity.val();
      numitemsValue = Number(numitemsValue) + Number(quantityValue);
      cartNumitems.text(numitemsValue);
    });
  });
}
